import { makeRequest, toCorrectFormDataValue, } from '@/js/libs/api';
import * as Types from './types';
import { encodeBody, fromDateType as fromDate, toDateType as toDate, fromDateTimeType as fromDateTime, toDateTimeUnixType as toDateTime, } from '@/js/libs/api-helpers';
export { fromDate, toDate, fromDateTime, toDateTime };
export const getTranslations = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    const path = '/api/ws-translate/translations';
    const pathInternal = '/api/translations';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.keyFilter !== undefined) {
        urlParams.append('keyFilter', params.keyFilter.toString());
    }
    if (params.keyValueFilter !== undefined) {
        urlParams.append('keyValueFilter', params.keyValueFilter.toString());
    }
    if (params.namespace !== undefined) {
        urlParams.append('namespace', params.namespace.toString());
    }
    if (params.missing !== undefined) {
        urlParams.append('missing', params.missing.toString());
    }
    if (params.language !== undefined) {
        urlParams.append('language', params.language.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getTranslations.paramsOrder = [{ type: 'parameters' }];
export const deleteTranslations = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.ids === undefined) {
        throw new Error('Missing required parameter: ids');
    }
    const path = '/api/ws-translate/translations';
    const pathInternal = '/api/translations';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.ids !== undefined) {
        urlParams.append('ids', params.ids.toString());
    }
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteTranslations.paramsOrder = [{ type: 'parameters' }];
export const getTranslationsByKeys = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.keys === undefined) {
        throw new Error('Missing required body: keys');
    }
    const path = '/api/ws-translate/translations/by-keys';
    const pathInternal = '/api/translations/by-keys';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.keys !== undefined) {
        body = params.keys;
    }
    if (params.language !== undefined) {
        urlParams.append('language', params.language.toString());
    }
    if (params.namespace !== undefined) {
        urlParams.append('namespace', params.namespace.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getTranslationsByKeys.paramsOrder = [{ type: 'body', paramName: 'keys' }, { type: 'parameters' }];
export const getAggregatedTranslations = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    const path = '/api/ws-translate/translations-aggregated';
    const pathInternal = '/api/translations-aggregated';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.language !== undefined) {
        urlParams.append('language', params.language.toString());
    }
    if (params.namespace !== undefined) {
        urlParams.append('namespace', params.namespace.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAggregatedTranslations.paramsOrder = [{ type: 'parameters' }];
export const getGeneratedTranslations = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-translate/translation/{id}/generate'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/translation/{id}/generate'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getGeneratedTranslations.paramsOrder = [{ type: 'parameters' }];
export const updateTranslation = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-translate/translation/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/translation/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateTranslation.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const deleteTranslation = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-translate/translation/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/translation/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteTranslation.paramsOrder = [{ type: 'parameters' }];
export const cloneTranslation = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-translate/translation/{id}/clone'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/translation/{id}/clone'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
cloneTranslation.paramsOrder = [{ type: 'parameters' }];
export const addTranslation = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.translation === undefined) {
        throw new Error('Missing required body: translation');
    }
    const path = '/api/ws-translate/translation';
    const pathInternal = '/api/translation';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.translation !== undefined) {
        body = params.translation;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
addTranslation.paramsOrder = [{ type: 'body', paramName: 'translation' }];
export const addMissingTranslation = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.translation === undefined) {
        throw new Error('Missing required body: translation');
    }
    const path = '/api/ws-translate/translation/add-missing';
    const pathInternal = '/api/translation/add-missing';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.translation !== undefined) {
        body = params.translation;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
addMissingTranslation.paramsOrder = [{ type: 'body', paramName: 'translation' }];
export const getNamespaces = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    const path = '/api/ws-translate/translations/namespaces';
    const pathInternal = '/api/translations/namespaces';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getNamespaces.paramsOrder = [{ type: 'parameters' }];
export * from './types';
export * from './constants';
